// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1a-mw","subheader":"ReorderModal_subheader__2smLX","listWrap":"ReorderModal_listWrap__3v8nI"};